<template>
  <div :class="componentClassName">
    <div class="m-dubbing-responder-setting__fields">
      <a-switch
        v-model="currentOverflowNotification"
        label="あふれ呼設定"
        :disabled="viewOnly"
        @change="handleOverflowNotificationChange"
      />
      <m-form-input v-if="currentOverflowNotification" label="あふれ呼の対応方法">
        <a-select-field
          id="dubbingResponseOptions"
          v-model="currentCondition"
          :options="dubbingOptions"
          :disabled="viewOnly"
          @change="handleOverflowConditionChange"
        />
      </m-form-input>
      <template
        v-if="currentOverflowNotification && (currentCondition === 'answering' || currentCondition === 'disconnect')"
      >
        <m-form-input label="ガイダンス内容">
          <template v-if="currentCondition === 'answering'">
            <a-text-field
              v-model="currentGuidance"
              class="m-dubbing-responder-setting__content-input"
              type="textarea"
              rows="7"
              placeholder="お電話ありがとうございます。●●株式会社でございます。
申し訳ございませんが、ただいまの時間は電話が込み合っています。
お急ぎのご用件でしたら、発信音の後に、ご用件とお名前をご伝言ください。お電話ありがとうございました。"
              :disabled="viewOnly"
              @change="handleOverflowGuidanceChange"
            />
          </template>
          <template v-if="currentCondition === 'disconnect'">
            <a-text-field
              v-model="currentGuidance"
              class="m-dubbing-responder-setting__content-input"
              type="textarea"
              rows="7"
              placeholder="お電話ありがとうございます。●●株式会社でございます。
申し訳ございませんが、ただいまの時間は電話が込み合っています。
誠に恐れ入りますが、営業時間内におかけ直し頂きますよう、お願い申し上げます。
お電話ありがとうございました。"
              :disabled="viewOnly"
              @change="handleOverflowGuidanceChange"
            />
          </template>
        </m-form-input>
        <div class="m-form-input">
          <div class="m-dubbing-responder-setting__button">
            <a-button
              v-show="!isVoicePlaying"
              id="play"
              variant="fill"
              color="primary"
              size="small"
              icon="play"
              icon-color="white"
              @click="handleTestButtonClick"
            >
              テスト再生
            </a-button>
            <a-button
              v-show="isVoicePlaying"
              id="stop"
              variant="fill"
              color="primary"
              size="small"
              icon="audio-pause"
              icon-color="white"
              :disabled="!currentOverflowNotification"
              @click="handleTestButtonClick('stop')"
            >
              テスト停止
            </a-button>
          </div>
        </div>
        <m-form-input v-if="currentCondition === 'answering' || currentCondition === 'disconnect'">
          <a-switch
            v-model="currentEmailNotification"
            label="メール通知"
            :disabled="viewOnly"
            @change="handleEmailNotificationChange"
          />
          <a-text-field
            id="mailaddress"
            v-model="currentAbsenceMail"
            class="m-user-invitation-item__fields-email-input ml-20 mb-20"
            name="absenceMail"
            type="text"
            placeholder="xxxx@kaisha.co.jp"
            :disabled="!currentEmailNotification || viewOnly"
            @change="handleEmailChange"
          />
        </m-form-input>
      </template>
      <template v-if="currentOverflowNotification && currentCondition === 'transfer'">
        <m-form-input label="電話番号">
          <a-text-field
            id="phoneNumber"
            v-model="currentTransferNumber"
            maxlength="11"
            :disabled="viewOnly"
            @change="handleOverflowTransferNumberChange"
          />
        </m-form-input>
      </template>
      <template v-if="currentOverflowNotification && currentCondition === 'voiceDX'">
        <m-form-input label="COTOHA Voice DX Basic番号名称">
          <a-select-field
            id="voiceDXPhoneNumberList"
            v-model="currentTransferNumber"
            :options="voicedxNumberlist"
            :disabled="viewOnly"
            class="mb-64"
            @change="handleOverflowTransferNumberChange"
          />
        </m-form-input>
      </template>
      <template v-if="currentOverflowNotification && currentCondition === 'user'">
        <m-form-input label="着信グループ名">
          <a-select-field
            id="groupName"
            v-model="currentGroupName"
            :options="userGroupOptions"
            :disabled="viewOnly"
            @change="handleOverflowGroupNameChange"
          />
        </m-form-input>
      </template>
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import AIcon from '@/components/atoms/icon';
import ASwitch from '@/components/atoms/switch';
import ATextField from '@/components/atoms/text-field';
import ASelectField from '@/components/atoms/select-field';
import MFormInput from '@/components/molecules/form-input';

export default {
  name: 'm-dubbing-responder-setting',
  components: {
    AButton,
    ASwitch,
    ASelectField,
    ATextField,
    MFormInput,
  },
  props: {
    responseMode: {
      type: String,
      default: null,
      required: true,
      validator(value) {
        return value.match(/(user|voiceDX|transfer)/);
      },
    },
    class: {
      type: String,
      default: '',
    },
    voiceList: {
      type: Array,
      default: new Array(0),
    },
    voice: {
      type: String,
      default: null,
    },
    phoneNumber: {
      type: String,
      default: null,
    },
    showEmail: {
      type: Boolean,
      default: false,
    },
    dubbingOptions: {
      type: Array,
      default: new Array(0),
    },
    voicedxNumberlist: {
      type: Array,
      default: new Array(0),
    },
    groupList: {
      type: Array,
      default: new Array(0),
    },
    overflowResponseMode: {
      type: String,
      default: '',
    },
    overflowCondition: {
      type: String,
      default: '',
    },
    overflowGuidance: {
      type: String,
      default: '',
    },
    overflowTransferNumber: {
      type: String,
      default: '',
    },
    overflowGroupName: {
      type: String,
      default: '',
    },
    overflowNotification: {
      type: Boolean,
      default: false,
    },
    isVoicePlaying: {
      type: Boolean,
      default: false,
    },
    responseDisabled: {
      type: Boolean,
      default: false,
    },
    overflowEmailNotification: {
      type: Boolean,
      default: false,
    },
    overflowAbsenceMail: {
      type: String,
      default: '',
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'play',
    'stop',
    'update:voice',
    'update:phoneNumber',
    'update:voicedxNumberlist',
    'update:groupList',
    'update:overflowCondition',
    'update:overflowGuidance',
    'update:overflowTransferNumber',
    'update:overflowGroupName',
    'update:overflowNotification',
    'update:overflowAbsenceMail',
    'update:overflowEmailNotification',
  ],
  data() {
    return {
      currentVoice: '',
      currentPhoneNumber: '',
      currentVoiceDXNumberName: '',
      currentUserGroup: '',
      currentOverflowResponseMode: '',
      currentCondition: '',
      currentGuidance: '',
      currentGuidanceUrl: '',
      currentTransferNumber: '',
      currentGroupName: '',
      currentOverflowNotification: false,
      currentEmailNotification: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('m-dubbing-responder-setting', this.responseMode);
      return `${baseClassName} ${this.class}`.trim();
    },
    userGroupOptions() {
      return this.groupList.map(group => {
        return {
          label: group.group_name,
          value: group.group_id,
        };
      });
    },
  },
  watch: {
    voice(val, oldValue) {
      this.currentVoice = this.voice;
    },
    phoneNumber(val, oldValue) {
      this.currentPhoneNumber = this.phoneNumber;
    },
    overflowNotification(val, oldValue) {
      this.currentOverflowNotification = this.overflowNotification;
    },
    overflowCondition(val, oldValue) {
      this.currentCondition = this.overflowCondition;
    },
    overflowGuidance(val, oldValue) {
      this.currentGuidance = this.overflowGuidance;
    },
    overflowTransferNumber(val, oldValue) {
      this.currentTransferNumber = this.overflowTransferNumber;
    },
    overflowGroupName(val, oldValue) {
      this.currentGroupName = this.overflowGroupName;
    },
    currentOverflowNotification(val) {
      if (val && !this.currentCondition && !this.overflowCondition) {
        this.currentCondition = 'answering';
        this.handleOverflowConditionChange();
      }
    },
    overflowAbsenceMail(val, oldValue) {
      this.currentAbsenceMail = this.overflowAbsenceMail;
    },
    overflowEmailNotification(val, oldValue) {
      this.currentEmailNotification = this.overflowEmailNotification;
    },
  },
  mounted() {
    if (this.voiceList.length > 0 && this.currentVoice === '') {
      this.currentVoice = this.voiceList[0].value || '';
    }
    if (this.voice) {
      this.currentVoice = this.voice;
    }
    if (this.voice) {
      this.currentPhoneNumber = this.phoneNumber;
    }
    if (this.overflowNotification) {
      this.currentOverflowNotification = this.overflowNotification;
    }
    if (this.overflowCondition) {
      this.currentCondition = this.overflowCondition;
    }
    if (this.overflowGuidance) {
      this.currentGuidance = this.overflowGuidance;
    }
    if (this.overflowTransferNumber) {
      this.currentTransferNumber = this.overflowTransferNumber;
    }
    if (this.overflowGroupName) {
      this.currentGroupName = this.overflowGroupName;
    }
    if (this.overflowEmailNotification) {
      this.currentEmailNotification = this.overflowEmailNotification;
    }
    if (this.overflowAbsenceMail) {
      this.currentAbsenceMail = this.overflowAbsenceMail;
    }
  },
  methods: {
    handleVoiceChange(e) {
      this.$emit('update:voice', this.currentVoice);
    },
    handlePhoneNumberChange(e) {
      this.$emit('update:phoneNumber', this.currentPhoneNumber);
    },
    handleTestButtonClick(e) {
      if (e === 'stop') {
        return this.$emit('stop');
      }
      this.$emit('play', {
        voice: this.currentVoice,
        content: this.currentGuidance,
      });
      return '';
    },
    handleOverflowConditionChange(e) {
      this.$emit('update:overflowCondition', this.currentCondition);
    },
    handleOverflowGuidanceChange(e) {
      this.$emit('update:overflowGuidance', this.currentGuidance);
    },
    handleOverflowTransferNumberChange(e) {
      this.$emit('update:overflowTransferNumber', this.currentTransferNumber);
    },
    handleOverflowGroupNameChange(e) {
      this.$emit('update:overflowGroupName', this.currentGroupName);
    },
    handleOverflowNotificationChange(e) {
      this.$emit('update:overflowNotification', this.currentOverflowNotification);
    },
    handleEmailChange() {
      this.$emit('update:overflowAbsenceMail', this.currentAbsenceMail);
    },
    handleEmailNotificationChange() {
      this.$emit('update:overflowEmailNotification', this.currentEmailNotification);
    },
  },
};
</script>
